import * as Yup from "yup";

import { IssueDateFormState } from "Components/Features/CheckOut/ProductTile/ProductDetails/CommonProductForms/IssueDate/issueDateFormTypes";
import { TextManager } from "Components/TextContext";
import { Validation } from "Components/TextContext/commonComponentEnums";

export type IValidationObject = {
  issueDate: Yup.DateSchema;
};

export const issueDateSchema = (): Yup.DateSchema<
  Date | undefined,
  Record<string, any>
> => {
  const { getText } = TextManager;
  return Yup.date()
    .typeError(getText(Validation.DATE_WRONG_FORMAT))
    .required(getText(Validation.CHOOSE_DATE));
};

export const validationObject = (): IValidationObject => ({
  issueDate: issueDateSchema(),
});

export const validationSchema =
  () => (): Yup.ObjectSchema<IssueDateFormState> => {
    return Yup.object(validationObject()).defined();
  };
